<kt-portlet>
  <kt-portlet-header [class]="'card-head-lg'">
    <ng-container ktPortletTitle>
      <span>Page Group List</span>
    </ng-container>
    <ng-container ktPortletTools>
      <div>
        <button
          (click)="createPageGroup()"
          mat-raised-button
          matTooltip="Create new Page Group"
          color="primary"
          type="button"
        >
          <span class="svg-icon-md">
            <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
            New Page Group
          </span>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>

  <kt-portlet-body>
    <div class="mat-table-wrapper">
      <mat-table
        class="lmat-elevation-z8"
        #table
        [dataSource]="dataSource"
        matSort
        #sort1="matSort"
        matSortActive="id"
        matSortDirection="desc"
        matSortDisableClear
      >
        <ng-container matColumnDef="name">
          <mat-header-cell class="email-cell" *matHeaderCellDef>Group name</mat-header-cell>
          <mat-cell class="email-cell" *matCellDef="let ele">{{ ele.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="pages">
          <mat-header-cell *matHeaderCellDef>Pages</mat-header-cell>
          <mat-cell *matCellDef="let ele">
            <div>
              <div style="width: 337px" *ngFor="let row of ele.pages">
                <span class="label label-primary label-dot mr-2"></span>
                <span class="font-weight-bold text-primary">{{ row.name }}</span>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef translate="TABLE.ACTIONS">Actions</mat-header-cell>
          <mat-cell *matCellDef="let ele">
            <button
              color="primary"
              matTooltip="Edit Page Group"
              (click)="editPageGroup(ele)"
              class="btn btn-icon btn-light btn-hover-primary btn-sm margin-2"
            >
              <span class="svg-icon svg-icon-md svg-icon-primary">
                <span inlineSVG="./assets/media/svg/icons/General/edit_icon.svg"></span>
              </span>
            </button>
            &nbsp;
            <button
              color="danger"
              matTooltip="Delete Category"
              (click)="deletePageGroups(ele)"
              class="btn btn-icon btn-light btn-hover-danger btn-sm margin-2"
            >
              <span class="svg-icon svg-icon-md svg-icon-danger">
                <span inlineSVG="./assets/media/svg/icons/General/delete_icon.svg"></span>
              </span>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>
  </kt-portlet-body>
</kt-portlet>
